// Module
var code = "<toolbar-color-menu colors=\"parent.elementColors\" menu-type=\"textBackground\" on-select=\"parent.updateTextboxBackgroundColor(color)\" transparent-button-text=\"No Background\"> </toolbar-color-menu> ";
// Exports
module.exports = code;